import React from 'react'
import { defaultProps } from './index'
import { ToolbarSection } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarSection'
import { ToolbarItem } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarItem'

export const TabellaDifferenzeCardItemSettings = (settingsProps) => {
  return (
    <>
      <ToolbarSection title="Settings" initOpen>
        <ToolbarItem
          propKey="block"
          propSubKey="icon"
          type="icon"
          label="Icon"
          defaultValue={defaultProps['icon']}
        />
      </ToolbarSection>
    </>
  )
}

export const TabellaDifferenzeCardItemFloatingSettings = () =>
  React.createElement(TabellaDifferenzeCardItemSettings, { floating: true })
